export default "__VITE_ASSET__BBITlOtR__"